import { WxColorStyleStrict } from '@metoceanapi/wxtiles-mbox/src/utils/wxtools';
import { WXTilesV3Layer } from '@mono/types/src/platmap';

export const stateToStyle = (state: WXTilesV3Layer): Partial<WxColorStyleStrict> => {
    if (state.styleOverrides.colorMap) return state.styleOverrides;

    return { ...state.styleOverrides, levels: levelsConfigToLevels(state.levels) };
};

interface levelsConfigToLevelsProps {
    min: number;
    max: number;
    interval?: number;
}
const levelsConfigToLevels = ({ min, max, interval }: levelsConfigToLevelsProps) => {
    if (!interval) return [min, max];
    const points = Math.floor((max - min) / interval);
    return [...Array.from({ length: points + 1 }, (_, i) => min + i * interval), max];
};
